import { FadeUp } from "@/components/Reveal";
import EnquiryForm from "@/components/EnquiryForm";
import { KanthaStitch, PaisleyMotif } from "@/components/Motifs";

const WORK_TYPES = [
  "Custom Fashion",
  "Art Commission",
  "Brand Collaboration",
  "Editorial / Styling",
  "Exhibition",
  "Workshop",
  "Textile Design",
  "Other",
];

const NOTES = [
  { title: "Custom Fashion", text: "Bespoke pieces begin with a conversation and a story. Allow 8–12 weeks for a made-to-order garment." },
  { title: "Art Commissions", text: "Paintings, textile art and alpana installations for homes, hotels and cultural spaces." },
  { title: "Collaborations", text: "Capsule collections, editorial styling and cultural projects with brands that respect craft." },
];

export default function WorkWithIpsita() {
  return (
    <main data-testid="work-with-page" className="pt-24">
      <section className="max-w-[1500px] mx-auto px-5 md:px-10 pt-10 md:pt-16 pb-16">
        <FadeUp>
          <p className="text-[11px] tracking-[0.3em] uppercase text-alta mb-6">Work with Ipsita</p>
          <h1 className="font-serif font-light text-4xl sm:text-5xl lg:text-7xl tracking-tight text-ink leading-[1.06]">
            Create Something Together
          </h1>
          <p className="mt-8 max-w-xl text-base font-light text-ink/65 leading-relaxed">
            The more you share — occasion, timeline, references, dreams — the more meaningful the reply. This is the beginning of a conversation, not a transaction.
          </p>
        </FadeUp>

        <div className="mt-14 grid grid-cols-1 sm:grid-cols-3 gap-6">
          {NOTES.map((n, i) => (
            <FadeUp key={n.title} delay={i * 0.08}>
              <div className="kantha-border bg-bone p-7 h-full">
                <PaisleyMotif className="w-7 h-7 text-terracotta/60 mb-4" />
                <h3 className="font-serif text-2xl text-ink">{n.title}</h3>
                <p className="mt-3 text-sm font-light text-ink/60 leading-relaxed">{n.text}</p>
              </div>
            </FadeUp>
          ))}
        </div>
      </section>

      <section className="bg-bone py-20 md:py-28">
        <div className="max-w-[900px] mx-auto px-5 md:px-10">
          <FadeUp className="mb-12">
            <h2 className="font-serif font-light text-3xl sm:text-4xl tracking-tight text-ink">The Enquiry</h2>
            <KanthaStitch className="mt-6" />
          </FadeUp>
          <EnquiryForm types={WORK_TYPES} defaultType="Custom Fashion" testidPrefix="work" />
        </div>
      </section>
    </main>
  );
}
